import { observer } from "mobx-react-lite";
import { XStack, YStack } from "tamagui";
import { useStores } from "../core/stores";
import { BlockLoading } from "../ui/Block";
import { Label } from "../ui/Label";
import { Subtext } from "../ui/Subtext";
import { UserAvatar } from "../ui/UserAvatar";

export const UserUI = observer(
  ({ uid, subText }: { uid: string; subText?: string }) => {
    const { usersStore } = useStores();

    const user = usersStore.byId.get(uid);

    if (!user) {
      return <BlockLoading />;
    }

    return (
      <XStack gap="$medium" alignItems="center" width={"100%"}>
        <UserAvatar userUid={user.uid} />
        <YStack>
          <Label
            textDecorationLine={user.data.archived ? "line-through" : undefined}
            numberOfLines={2}
          >
            {user.data.displayName}
          </Label>
          {subText && <Subtext>{subText}</Subtext>}
        </YStack>
      </XStack>
    );
  },
);
